/* eslint-disable quote-props */
export default {
    'ok': 'Ok',
    'Search': 'Cerca',
    'Address': 'Adreça',
    'Routing': 'Ruta',
    'From here': 'Des d\'aquí',
    'Waypoint here': 'Passant per aquí',
    'Destination here': 'Fins aquí',
    'Distance': 'Distància',
    'Line': 'Línia',
    'Road': 'Carretera',
    'Area': 'Àrea',
    'fullScreen': 'Pantalla completa',
    'gasStation': 'Benzinera',
    'gasstations': 'Benzineres',
    'naturalgasstations': 'Estacions de gas natural',
    'electricchargers': 'Carregadors elèctrics',
    'detailedLocation': 'Localització detallada',
    'street': 'Carrer',
    'city': 'Localitat',
    'postalCode': 'Codi postal',
    'municipality': 'Municipi',
    'regionLevel2': 'Província',
    'regionLevel1': 'Comunitat',
    'country': 'País',
    'altitude': 'Altitud',
    'xy': 'Y,X',
    'maximumSpeed': 'Velocitat màxima',
    'copy': 'Copiar',
    'go': 'Anar',
    'call': 'Trucar',
    'send:': 'Enviar',
    'calculateIsochrone': 'Calcular isòcrona',
    'car': 'Cotxe',
    'bicycle': 'Bicicleta',
    'onFoot': 'A peu',
    'simplified': 'Simplificada',
    'detailed': 'Detallada',
    'starting': 'Inici',
    'arrival': 'Arribada',
    'increments': 'Increments',
    'maxWeight': 'Pes màx.',
    'maxAxleWeight': 'Pes eix màx.',
    'maxHeight': 'Alçada màx.',
    'maxLength': 'Longitud màx.',
    'maxWidth': 'Amplada màx.',
    'maxSpeed': 'Vel màx.',
    'showRoadRestrictions': 'Mostrar restriccions viàries per camions',
    'dangerousGoods': 'Mercaderies perilloses',
    'trc': 'Codi de Restricció de Túnel',
    'trucks': 'Camions',
    'temporalRestrictions': 'Restriccions temporals',
    'startTime': 'Hora inici',
    'endTime': 'Hora final',
    'morning': 'Matí',
    'afternoon': 'Tarda',
    'price': 'Preu',
    'schedule': 'Horari',
    'font': 'Font',
    'liveTraffic': 'Trànsit actual',
    'forecastTraffic': 'Trànsit previst',
    'slow': 'Lent',
    'fast': 'Ràpid',
    'roadWorks': 'Obres',
    'AbnormalTraffic': 'Trànsit anormal',
    'queueingTraffic': 'Trànsit amb cues',
    'slowTraffic': 'Trànsit lent',
    'stationaryTraffic': 'Trànsit aturat',
    'Accident': 'Accident',
    'accident': 'Accident',
    'EnvironmentalObstruction': 'Obstrucció ambiental',
    'flooding': 'Inundació',
    'landslips': 'Esllavissades',
    'rockfalls': 'Despreniments de roques',
    'GeneralObstruction': 'Obstrucció general',
    'incident': 'Incident',
    'objectOnTheRoad': 'Objecte a la carretera',
    'obstructionOnTheRoad': 'Obstrucció a la carretera',
    'shedLoad': 'Pèrdua de càrrega',
    'MaintenanceWorks': 'Treballs de manteniment',
    'maintenanceWork': 'Treballs de manteniment',
    'other': 'Altres',
    'resurfacingWork': 'Treballs de reasfaltatge',
    'MaintenanceWorks roadworks': 'Treballs de manteniment, obres',
    'MaintenanceWorks roadworks, maintenanceWork': 'Treballs de manteniment, obres, treballs de manteniment',
    'roadworks': 'Obres',
    'roadworks, maintenanceWork': 'Obres, treballs de manteniment',
    'roadworks, maintenanceWork, resurfacingWork': 'Obres, treballs de manteniment, treballs de reasfaltatge',
    'roadworks, resurfacingWork': 'Obres, treballs de reasfaltatge',
    'NetworkManagement': 'Gestió de xarxa',
    'contraflow': 'Circulació en sentit contrari',
    'intermittentShortTermClosures': 'Tancaments intermitents de curta durada',
    'laneOrCarriagewayClosed': 'Carril o calçada tancada',
    'narrowLanes': 'Carrils estrets',
    'restrictions': 'Restriccions',
    'roadClosed': 'Carretera tancada',
    'singleAlternateLineTraffic': 'Trànsit alternatiu per un sol carril',
    'VehicleObstruction': 'Obstrucció per vehicle',
    'brokenDownVehicle': 'Vehicle avariat',
    'slowMovingMaintenanceVehicle': 'Vehicle de manteniment lent',
    'snowplough': 'Lleva neu',
    'vehicleOnFire': 'Vehicle en flames',
    'obstruction': 'Obstrucció',
    'monday': 'Dilluns',
    'tuesday': 'Dimarts',
    'wednesday': 'Dimecres',
    'thursday': 'Dijous',
    'friday': 'Divendres',
    'saturday': 'Dissabte',
    'sunday': 'Diumenge',
    'direction': 'Direcció',
    'mapCenter': 'Centre del mapa',
    'maxResults': 'Resultats màx.',
    'maxRadius': 'Radi màx.',
    'viewOnMap': 'Veure en el mapa',
    'proximity': 'Proximitat',
    'selectCategories': 'Seleccionar categories',
    'minimizeRoutingMenu': 'Minimitzar menú ruta',
    'closeRouteMenu': 'Tancar menú ruta',
    'writeOrClickMap': 'Escriu o fes click en el mapa',
    'routeTo': 'Cap a...',
    'waypoint': 'Etapa ...',
    'addWaypoint': 'Afegir punt de pas',
    'cleanRoute': 'Netejar ruta',
    'saveRoute': 'Guardar ruta',
    'printRoute': 'Imprimir ruta',
    'modifyRouteOptions': 'Modificar opcions de ruta',
    'logisticsRoute': 'Ruta per a camions',
    'routeType': 'Tipus ruta',
    'time': 'Temps',
    'restTime': 'Temps de descans',
    'distance': 'Distància',
    'avoidTolls': 'Evitar peatges',
    'realtime': 'Temps real',
    'optimizedRoute': 'Ruta optimitzada',
    'addedCosts': 'Costos afegits',
    'departureTime': 'Hora de sortida',
    'moreDetails': 'Més detalls',
    'routeCar': 'Ruta en cotxe',
    'routeTruck': 'Ruta en camió',
    'withoutTraffic': 'sense trànsit',
    'ofRest': 'de descans (tacògraf)',
    'ZBEInfo': 'Informació sobre aquesta zona de baixa emissió',
    'hour': 'Hora',
    'roadRestrictions': 'Restriccions de carreteres',
    'addBreakTime': 'Afegir temps de descans (tacògraf)',
    'twoDrivers': 'Dos conductors',
    'refresh': 'Actualitzar',
    'disabled': 'Desactivat',
    'sunLight': 'Il·luminació del sol',
    'neighborhoods': 'Barris',
    'postalcodes': 'Codis postals',
    'municipalities': 'Municipis',
    'routeStopsFrom': 'Des de:',
    'routeStopsThrought': 'passant per:',
    'routeStopsTo': 'cap a:',
    'routeStopsTrafficDelay': 'retràs pel trànsit actual',
    'routeSummaryDetails': 'RUTA DETALLADA',
    'routeSummaryTraficJam': 'retràs',
    'searchAddress': 'Adreça',
    'searchPostalCode': 'Codi postal',
    'searchCoordinates': 'Coordenades',
    'searchLocality': 'Localitat',
    'searchPOIs': 'POIs',
    'searchSearchBtn': 'Cerca',
    'searchNearestAddress': 'Adreça més propera',
    'searchSelectCountry': 'Seleccionar país',
    'searchAllCountries': 'Tots els països',
    'searchProjection': 'Projecció',
    'searchXCoordinate': 'Coordenada X',
    'searchYCoordinate': 'Coordenada Y',
    'searchCandidates': 'Candidats',
    'tooltipAdvancedSearch': 'Cerca avançada',
    'tooltipRouting': 'Calcular ruta',
    'tooltipPois': 'Punts d’interès',
    'tooltipMeteo': 'Predicció meteorològica',
    'tooltipGasStations': 'Benzineres',
    'tooltipTraffic': 'Trànsit',
    'tooltipZBE': 'Zones de baixes emissions',
    'tooltipStreetView': 'Vista de carrer',
    'tooltipClean': 'Netejar mapa',
    'tooltipDraw': 'Dibuixar',
    'tooltipLayerSwitcher': 'Canviar fons de mapa',
    'tooltipLayerRegion': 'Afegir capes administratives',
    'tooltipLogisticsRestrictions': 'Mostrar restriccions viàries per a camions',
    'tooltipIsochrones': 'Calcular isòcrones',
    'tooltipBuildings3D': 'Veure edificis en vista 3D',
    'rainRadar': 'Radar de pluja',
    'activeFires': 'Incendis actius (<24h)',
    'notificationRouteCantGetPosition': 'No es pot obtenir la seva localització. Si us plau, introdueixi l’adreça en el formulari d’origen.',
    'notificationErrorSavingKML': 'Error guardant el KML.',
    'notificationErrorGetPostalCode': 'No es pot obtenir el codi postal. Error: ',
    'notificationControlAlreadyExists': 'El control ja existeix:',
    'notificationSelectCategories': 'Seleccioni primer les categories de punts d’interès.',
    'notificationPoisNotFound': 'Punts d’interès no trobats.',
    'notificationDrawIsochrone': 'Fes click en el punto del mapa on vulguis calcular la isòcrona',
    'notificationErrorGetPathRouting': 'No s\'ha pogut trobar el camí de la ruta, revisi els punts de pas',
    'assertMapNotDefined': 'Map not defined',
    'assertFeatureExists': 'Feature already exists',
    'assertUnknownBaseLayer': 'Unknown setBaseLayer: ',
    'assertLayerNotSpecified': 'Layer not specified',
    'asserInvalidObjectLonLat': 'Not a \'cercalia.LonLat\' type object',
    'assertUknownWeight': 'Uknown weight: ',
    'assertParameterIsNotFunction': 'Parameter is not a callback function',
    'assertUknownParameter': 'Uknown parameter: ',
    'assertOriginInvalid': 'Can\'t calculate route. Invalid origin: ',
    'assertStepInvalid': 'Can\'t calculate route. Invalid step: ',
    'assertDestinationInvalid': 'Can\'t calculate route. Invalid destination: ',
    'assertProjectionNotDefined': 'Layer projection not declared: ',
    'assertGpsNotPosition': 'Can\'t get GPS position.',
};
//# sourceMappingURL=ca.js.map